import {
    REIS_RESULT_CLEAR,
    REIS_RESULT_STARTED,
    REIS_RESULT_SUCCESS,
    REIS_RESULT_FAILURE,
    REIS_FILTER_SELECTION,
    REIS_UPDATE_REIS_TEXT,
    REIS_UPDATE_SORT,
    REIS_RESULT_UPDATE_STARTED
  } from "../constants/reis.constant";
  import { OrderType, SearchOrder } from "../constants/search.constant";
  
  const initialState = {
    updating: 0,
    loading: false,
    searchstatus: "",
    search_results: [],
    totalResult: 0,
    totalPages: 0,
    error: null,
    filterOpts: {},
    selFilterOpts: {},
    suggestionInfo: { loading: false, searchList: [], history: [] },
    sortInfo: { key: SearchOrder.published, order: OrderType.desc },
  };
  
  export default function researchReducer(state = initialState, action) {
    switch (action.type) {
      case REIS_RESULT_CLEAR:
        return {
          loading: false,
          searchstatus: "",
          search_results: [],
          totalResult: 0,
          totalPages: 0,
          error: null,
          filterOpts: {},
          selFilterOpts: {},
          suggestionInfo: { loading: false, searchList: [], history: [] },
          sortInfo: { key: SearchOrder.published, order: OrderType.desc },
        };
      case REIS_RESULT_STARTED:
        return {
          ...state,
          loading: true,
        };
      case REIS_RESULT_UPDATE_STARTED:
        return {
          ...state,
          updating: state.updating + 1,
        };
      case REIS_RESULT_SUCCESS:
        return {
          ...state,
          loading: false,
          updating: (state.updating > 0) ? state.updating - 1 : 0,
          searchstatus: action.payload.status,
          search_results: action.payload.data,
          totalResult: action.payload.totalResult,
          totalPages: action.payload.totalPages,
          filterOpts: action.payload.filterOpts,
        };
      case REIS_RESULT_FAILURE:
        return {
          ...state,
          loading: false,
          updating: (state.updating > 0) ? state.updating - 1 : 0,
          error: action.payload.error,
          search_results: [],
        };
      case REIS_FILTER_SELECTION:
        return {
          ...state,
          selFilterOpts: action.payload,
        };
      case REIS_UPDATE_REIS_TEXT:
        return {
          ...state,
          searchTxt: action.payload,
        };
      case REIS_UPDATE_SORT:
        return {
          ...state,
          sortInfo: action.payload,
        };
      default:
        return state;
    }
  }
  